module.exports = __webpack_public_path__ + "img/advance-2-en.2b8d0a6b.png";